/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

import DbBaseObject from '@shared/DbBaseObject.js';
import PaymentIntegrationItem from "@shared/Billing/PaymentIntegrationItem";
import {Type} from "class-transformer";
import PaymentIntegrationType from "@shared/Billing/PaymentIntegrationType";
import PayPalIntegrationItem from "@shared/Billing/PayPalIntegrationItem";
import StripeIntegrationItem from "@shared/Billing/StripeIntegrationItem";
import CloverIntegrationItem from "@shared/Billing/CloverIntegrationItem";


export default class PaymentIntegrations extends DbBaseObject{

	static MAIN_ID = "mainDoc"

	userId: string = null //this is coachId for reference

	isCardPaymentEnabled: boolean = true
	isPayPalPaymentEnabled: boolean = true

	creditCardMethod: PaymentIntegrationType = null

	@Type(() => PayPalIntegrationItem)
	payPalIntegration: PaymentIntegrationItem = null

	@Type(() => StripeIntegrationItem)
	stripeIntegration: PaymentIntegrationItem = null

	@Type(() => CloverIntegrationItem)
	cloverIntegration: PaymentIntegrationItem = null

	@Type(() => PaymentIntegrationItem)
	manualInstructions: PaymentIntegrationItem[] = []


	constructor() {
		super();
		this.id = PaymentIntegrations.MAIN_ID
		setTimeout(() => this.setupDefaultCreditCardMethod())
		console.log("PaymentIntegrations: constructor: ", this)
	}

	setupDefaultCreditCardMethod(){
		if(!this.creditCardMethod && this.stripeIntegration){
			this.creditCardMethod = this.stripeIntegration.type
		} else if(!this.creditCardMethod && this.cloverIntegration){
			this.creditCardMethod = this.cloverIntegration.type
		}
	}

	getCreditCardIntegration(){
		if(!this.isCardPaymentEnabled){
			return null
		}
		this.setupDefaultCreditCardMethod()
		let integrationItem
		switch (this.creditCardMethod){
			case PaymentIntegrationType.STRIPE:
				if(this.isStripeIntegrated()){
					integrationItem = this.stripeIntegration
				}
				break
			case PaymentIntegrationType.CLOVER:
				if(this.isCloverIntegrated()){
					integrationItem = this.cloverIntegration
				}
				break
		}
		return integrationItem
	}

	hasIntegrations(){
		let hasPayPalIntegration = this.isPayPalIntegrated()
		let hasStripeIntegration = this.isStripeIntegrated()
		let hasCloverIntegration = this.isCloverIntegrated()

		return hasPayPalIntegration || hasStripeIntegration || hasCloverIntegration
	}
	isPayPalIntegrated(){
		return !!(this.isPayPalPaymentEnabled && this.payPalIntegration && this.payPalIntegration.integrated())
	}

	isStripeIntegrated(){
		return !!(this.isCardPaymentEnabled && this.isStripeIntegratedIgnoreDisabled())
	}

	isCloverIntegrated(){
		return !!(this.isCardPaymentEnabled && this.isCloverIntegratedIgnoreDisabled())
	}

	isStripeIntegratedIgnoreDisabled(){
		return !!(this.stripeIntegration && this.stripeIntegration.integrated())
	}

	isCloverIntegratedIgnoreDisabled(){
		return !!(this.cloverIntegration && this.cloverIntegration.integrated())
	}

	isCardPaymentIntegrated(){
		return this.isCloverIntegrated() || this.isStripeIntegrated()
	}

	isCardPaymentIntegratedIgnoreDisabled(){
		return this.isCloverIntegratedIgnoreDisabled() || this.isStripeIntegratedIgnoreDisabled()
	}




	setIntegrationItem(paymentIntegrationItem){
		switch (paymentIntegrationItem.type) {
			case PaymentIntegrationType.PAYPAL:
				this.payPalIntegration = paymentIntegrationItem;
				break;
			case PaymentIntegrationType.STRIPE:
				this.stripeIntegration = paymentIntegrationItem;
				break;
			case PaymentIntegrationType.MANUAL:
				this.setManualIntegrationItem(paymentIntegrationItem)
				break;
			case PaymentIntegrationType.CLOVER:
				this.cloverIntegration = paymentIntegrationItem;
				break;
		}
	}

	setManualIntegrationItem(paymentIntegrationItem){
		let index = this.manualInstructions.findIndex(manual => manual.id == paymentIntegrationItem.id)
		if(index >= 0){
			this.manualInstructions[index] = paymentIntegrationItem
		} else {
			this.manualInstructions.push(paymentIntegrationItem)
		}
	}
}



